
import React from 'react';
import ReactDOM from 'react-dom';

class Products extends React.Component
{
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.state = {
            products: []
        };
    }

    componentWillMount()
    {
        let self = this;

        axios.get('api/products/list/' + project)
            .then(response => {
                self.setState({
                    products: response.data
                });
            })
            .catch(error => {

            });
    }

    componentDidMount()
    {
    }

    search()
    {
        let self = this;
        let search = $('#productInputSearch').val();

        axios.get('api/products/search/' + project + '/' + search)
            .then(response => {
                self.setState({
                    products: response.data
                });
            })
            .catch(error => {

            });
    }

    renderItem(item)
    {
        return(
            <tr key={item.id}>
                <td>{item.key}</td>
                <td>{item.description}</td>
                <td>{item.expiration_time}</td>
                <td>{item.commerce}</td>
                <td>{item.status}</td>
                <td>
                    <a href={"/products/edit/" + item.id} className={"btn btn-info waves-effect waves-light"}>
                        <i className="fa fa-pencil"></i> Editar
                    </a>
                </td>
            </tr>
        );
    }

    render()
    {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className={"panel-header"}>
                                    <div className={"row"}>
                                        <div className="col-md-4 col-md-offset-4" style={{ paddingTop: "25px", paddingBottom: "25px" }}>
                                            <div className="col-md-8 col-md-offset-2">
                                                <img src="img/products.png" className="img-responsive" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="panel-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label>Buscador</label>
                                            <div className="input-group m-t-10">
                                                <input type="text" id="productInputSearch" className="form-control"/>
                                                <span className="input-group-btn">
                                                    <button type="button" className="btn waves-effect waves-light btn-primary" onClick={this.search}>
                                                        <i className={"fa fa-search"}></i> Buscar
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                        <div className={"col-md-6"}></div>
                                        <div className="col-md-2">
                                            <div className="pull-right" style={{ marginTop: "35px" }}>
                                                <a href={'/products/register'} className="form-control btn btn-success">
                                                    <i className={"fa fa-plus"}></i> Agregar
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.products.length !== 0 &&
                                        <div className="row">
                                            <div className="col-md-12 p-20">
                                                <table className="table table-striped m-0">
                                                    <thead>
                                                    <tr>
                                                        <th>Clave</th>
                                                        <th>Descripción</th>
                                                        <th>Caducidad</th>
                                                        <th>Comercio</th>
                                                        <th>Status</th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.products.map(this.renderItem)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Products;

if (document.getElementById('products-component')) {
    ReactDOM.render(<Products />, document.getElementById('products-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/Products.jsx